import React from 'react'

function ProductionStageHeader() {
    return (
        <thead
            className="ProductionStageHeader"
            style={{ background: '#e9ecef' }}
        >
            <tr>
                <th className="name">Tên công đoạn</th>
                {/* <th className="key">Key</th> */}
                <th className="partner">Đối tác sản xuất</th>
                {/* <th className="Status">Trạng thái</th> */}
                <th className="Create_at">Ngày tạo</th>
                <th className="Update_at">Ngày cập nhật</th>
                <th className="Action">Hành động</th>
            </tr>
        </thead>
    )
}

export default ProductionStageHeader